<template>
  <div>
    <DeploymentTestingPanel />

    <!-- Quick Access Buttons -->
    <b-row class="mt-4">
      <b-col md="4">
        <b-card class="text-center">
          <feather-icon
            icon="ZapIcon"
            size="48"
            class="mb-2 text-warning"
          />
          <h6>Quick Test</h6>
          <p class="text-muted small">
            Simulate deployment notification
          </p>
          <b-button
            variant="warning"
            block
            @click="quickTest"
          >
            Test Now
          </b-button>
        </b-card>
      </b-col>

      <b-col md="4">
        <b-card class="text-center">
          <feather-icon
            icon="SettingsIcon"
            size="48"
            class="mb-2 text-info"
          />
          <h6>Console Access</h6>
          <p class="text-muted small">
            Open browser console
          </p>
          <b-button
            variant="info"
            block
            @click="openConsoleHelp"
          >
            Console Commands
          </b-button>
        </b-card>
      </b-col>

      <b-col md="4">
        <b-card class="text-center">
          <feather-icon
            icon="BookIcon"
            size="48"
            class="mb-2 text-success"
          />
          <h6>Test Guide</h6>
          <p class="text-muted small">
            Testing instructions
          </p>
          <b-button
            variant="success"
            block
            @click="showTestGuide"
          >
            View Guide
          </b-button>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BButton,
} from 'bootstrap-vue'
/* eslint-disable import/no-extraneous-dependencies */
import Swal from 'sweetalert2'
import DeploymentTestingPanel from '@/views/components/DeploymentTestingPanel.vue'
import deploymentDetector from '@/utils/deploymentDetector'

export default {
  name: 'DeploymentTesting',
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    DeploymentTestingPanel,
  },
  methods: {
    quickTest() {
      deploymentDetector.showDeploymentNotification('1.2.0-test')
    },

    openConsoleHelp() {
      Swal.fire({
        title: '🛠️ Console Testing Commands',
        html: `
          <div style="text-align: left; font-family: monospace; background: #f8f9fa; padding: 15px; border-radius: 5px;">
            <p><strong>Available commands in browser console:</strong></p>
            <p>• <code>window.deploymentDetector.manualCheck()</code><br/>
               <span style="font-size: 12px; color: #666;">Manual deployment check</span></p>

            <p>• <code>window.deploymentDetector.showDeploymentNotification()</code><br/>
               <span style="font-size: 12px; color: #666;">Show notification popup</span></p>
            <p>• <code>window.deploymentDetector.checkBundleVersion()</code><br/>
               <span style="font-size: 12px; color: #666;">Check for bundle changes</span></p>

            <p>• <code>navigator.serviceWorker.getRegistrations()</code><br/>
               <span style="font-size: 12px; color: #666;">Check service worker status</span></p>
          </div>
        `,
        icon: 'info',
        confirmButtonText: 'Got it!',
        width: 600,
      })
    },

    showTestGuide() {
      Swal.fire({
        title: '📋 Testing Guide',
        html: `
          <div style="text-align: left; padding: 10px;">
            <h6>🔄 Service Worker Testing:</h6>
            <ol>
              <li>Open browser dev tools (F12)</li>
              <li>Go to Application tab → Service Workers</li>
              <li>Click "Update" to trigger update detection</li>
              <li>Or use the "Force SW Update" button</li>
            </ol>
            
            <h6>📦 Bundle Change Testing:</h6>
            <ol>
              <li>Build your app: <code>npm run build</code></li>
              <li>Change version in package.json</li>
              <li>Build again with new version</li>
              <li>Serve both versions to test detection</li>
            </ol>
            
            <h6>🎯 Quick Testing:</h6>
            <ol>
              <li>Use the testing panel buttons above</li>
              <li>Check browser console for logs</li>
              <li>Use "Show Test Notification" for immediate results</li>
            </ol>
            
            <h6>🌐 Production Simulation:</h6>
            <ol>
              <li>Build: <code>npm run build:production</code></li>
              <li>Serve with http-server or similar</li>
              <li>Deploy new version to different port</li>
              <li>Switch between versions to test</li>
            </ol>
          </div>
        `,
        icon: 'question',
        confirmButtonText: 'Start Testing!',
        width: 700,
      })
    },
  },
}
</script>
